/**
 * @generated SignedSource<<284cd0bb5bc49df303a6069d28b60839>>
 * @relayHash b357edcd1e06ae795fc45b4bee7ec398
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b357edcd1e06ae795fc45b4bee7ec398

import { ConcreteRequest } from 'relay-runtime';
export type chFavoriteAgentsByPatientQuery$variables = {
  patientId: string;
};
export type chFavoriteAgentsByPatientQuery$data = {
  readonly patientById: {
    readonly favoriteAgentUserNames: ReadonlyArray<string>;
  } | null;
};
export type chFavoriteAgentsByPatientQuery = {
  response: chFavoriteAgentsByPatientQuery$data;
  variables: chFavoriteAgentsByPatientQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "patientId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoriteAgentUserNames",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chFavoriteAgentsByPatientQuery",
    "selections": [
      {
        "alias": "patientById",
        "args": (v1/*:: as any*/),
        "concreteType": "ch_Patient",
        "kind": "LinkedField",
        "name": "ch_patientById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chFavoriteAgentsByPatientQuery",
    "selections": [
      {
        "alias": "patientById",
        "args": (v1/*:: as any*/),
        "concreteType": "ch_Patient",
        "kind": "LinkedField",
        "name": "ch_patientById",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "b357edcd1e06ae795fc45b4bee7ec398",
    "metadata": {},
    "name": "chFavoriteAgentsByPatientQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9cd9db90106cf7f7810c243458a5fe95";

export default node;
